import Backbone from "backbone";

import template from "../templates/item.jst";

import EditableSelectInputView from "shared/controls/editable_select_input_view";

import "shared/jquery/icon";
import { bindErrorsToFormField } from "shared/stickit_helpers";

import ExceptionHandling from "shared/logging/exception_handling";

import Item from "backdraft-app/src/listing/item";

import _ from "underscore";
import $ from "jquery";

export default class CustomDataListItem extends Item {
  get events() {
    return {
      "click .remove-custom-data-value": "_onRemoveClick",
      "click .override-custom-data-value": "_onOverrideClick",
      "click .restore-custom-data-value": "_onRestoreClick"
    };
  }

  get bindings() {
    return {
      "[data-mount='custom-data-value'] [data-mount='input']": 'fieldValue',
      ".field-source": "friendlySourceClassName",
      "[data-mount='custom-data-value'] [data-mount='errors']": bindErrorsToFormField("Field Value", "fieldValue", { addPrefix: false }),
      "[data-mount='custom-data-partner-name'] [data-mount='errors']": bindErrorsToFormField("Field Partner Name", "fieldPartnerName", { addPrefix: false })
    };
  }

  initialize(...args) {
    super.initialize(...args);

    this.model.on("change:inherited", () => {
      if (this.model.get("inherited") === false) {
        this.$('.field-source').addClass('override-source');
        this.$('.override-field-source').html(this.model.get('modalReference').get("friendlyModalClassName"));
        this.$("[data-mount='custom-data-value'] [data-mount='input']").html('').prop('disabled', false);

        if (_.any(this.model.getFieldValues())) {
          this.$el.find('.field-value-select2 .select2-initial').prop("disabled", false);
          this._showValueSelect2();
        } else {
          this._showValueInput();
        }

        this._storeInheritedValues(this.model.get("friendlySourceClassName"), this.model.get("fieldValue"));

        // Set new values to override
        this.model.set("friendlySourceClassName", this.model.get('modalReference').get('friendlyModalClassName'), { silent: true });
        this.model.set("fieldValue", '', { silent: true });

        this.$('.override-custom-data-value').hide();
        this.$('.restore-custom-data-value').show();
      }
    });

    this.model.on("change:restore", () => {
      if (this.model.get("restore") === true) {
        this.$('.restore-custom-data-value').hide();
        this.$('.override-custom-data-value').show();

        // Restore
        this.model.set("inherited", true, { silent: true });
        this.model.set("friendlySourceClassName", this.model.get("fieldSourceOriginal"));
        this.model.set("fieldValue", this.model.get("fieldValueOriginal"));

        this.model.unset("fieldSourceOriginal");
        this.model.unset("fieldValueOriginal");

        this._updateFieldValue();

        this.$('.field-source').removeClass('override-source');
        this.$('.override-field-source').html('');
        this.$('[data-mount=input]').prop('disabled', true);
        this.model.set("restore", false, { silent: true });
      }
    });

    this.model.on("change:fieldValue", () => {
      this.model.isValid();
    });
  }

  render() {
    this.$el.html(template());
    this.$el.icon();
    this.$('[data-toggle="tooltip"]').tooltip();
    this._updateFieldValue();
    this._renderFieldSelect();
    if (this.model.get("fieldValue").length && !this.model.get('inherited')) {
      this.$('[data-mount=input]').prop('disabled', false);
    }
    this.stickit();
    return this;
  }

  _renderFieldSelect() {
    const filter = new EditableSelectInputView({
      type: "select",
      width: '250px',
      placeholder: "Select a marketing data field...",
      attr: "friendly_name",
      pageSize: 10,
      model: new Backbone.Model(),
      textAttr: 'friendly_name',
      history: false,
      wrapperClass: "select2-wrapper",
      select2Options: {
        data: this.getFriendlyNamesByGroup(),
        matcher: this._searchAndFilterOutSelectedFields.bind(this)
      },
      events: {
        "change select": ({ currentTarget }) => {
          this.removeSelectedField(this.model.get('fieldPartnerName'));
          this.resetFieldModel(currentTarget.value);
          this._renderFieldValueSelect();
          this._enableInputWhenPartnerNamePresent();
        }
      }
    });

    this.$el.find('.field-name').append(filter.render().$el);

    if (!_.isEmpty(this.model.get('inheritedValue'))) {
      this.$el.find('.field-name .select2-initial').prop("disabled", true);
    }
  }

  resetFieldModel(partnerName) {
    this.model.set('fieldPartnerName', partnerName);
    this.model.set('dataType', this.model.get('modalReference').getDataType(this.model.get('fieldPartnerName')));
    this.model.set('fieldValue', '');
    this.model.set('friendlySourceClassName', this.model.get('modalReference').get('friendlyModalClassName'));
    this.selectedFieldNames().push(this.model.get('fieldPartnerName'));
    this.model.set('errors', "");
  }

  getFriendlyNamesByGroup() {
    const fields = _.map(this.model.get('modalReference').get('data'), ({ partner_name: partnerName, friendly_name: friendlyName, data_type: dataType }) => ({
      id: partnerName,
      text: friendlyName,
      data_type: dataType,
      selected: friendlyName === this.model.get('fieldFriendlyName')
    }));

    const GROUP_NAMES = {
      business_object: { name: "Categories", order: 0 },
      string: { name: "Short Text Fields", order: 1 },
      url: { name: "Long Text Fields", order: 2 }
    };

    const groups = _.groupBy(fields, attrs => attrs.data_type);
    const result = [];
    _.each(groups, (data, key) => {
      if (GROUP_NAMES[key]) {
        result.push({ text: GROUP_NAMES[key].name, children: data, order: GROUP_NAMES[key].order });
      } else {
        ExceptionHandling.logWarning(`Unknown group name in custom data modal: ${key}`);
        result.push({ text: key, children: data, order: GROUP_NAMES.length });
      }
    });

    return _.sortBy(result, ({ order }) => order);
  }

  selectedFieldNames() {
    return this.model.get('modalReference').get('selectedPartnerNames').get('partnerName');
  }

  removeSelectedField(fieldPartnerName) {
    if (fieldPartnerName) {
      const index = this.selectedFieldNames().indexOf(fieldPartnerName);
      this.selectedFieldNames().splice(index, 1);
    }
  }

  _searchAndFilterOutSelectedFields(options, data) {
    const field = $.extend(true, {}, data);

    // handle children (optgroups in select)
    if (field.children) {
      for (let c = field.children.length - 1; c >= 0; c--) {
        const child = field.children[c];
        const inherited = _.has(this.model.get('modalReference').get("inherited_custom_data"), child.id);
        const alreadySelected = _.contains(this.selectedFieldNames(), child.id) || inherited;
        const matchesSearch = this._select2SearchMatcher(options, child);

        // remove from list if it is selected in another row already, or if there is a search and this item isn't a match
        if (alreadySelected || !matchesSearch) {
          field.children.splice(c, 1);
        }
      }

      if (field.children.length > 0) {
        return field;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  _select2SearchMatcher({ term }, { text }) {
    return !term || (text.toUpperCase().indexOf(term.toUpperCase()) >= 0);
  }

  _storeInheritedValues(source, value) {
    this.model.set("fieldSourceOriginal", source, { silent: true });
    this.model.set("fieldValueOriginal", value, { silent: true });
  }

  _updateFieldValue() {
    if (this.model.get('inherited')) {
      this.$('[name=field-value]').prop('disabled', true);
      this.$('.override-custom-data-value').show();
    } else {
      this.$('.remove-custom-data-value').show();
    }
    this._renderFieldValueSelect();
  }

  _renderFieldValueSelect() {
    const fieldValues = this.model.getFieldValues();
    if (_.any(fieldValues)) {
      const filter = new EditableSelectInputView({
        type: "select",
        width: '192px',
        placeholder: "Select a field value...",
        attr: "field_value",
        pageSize: 10,
        model: new Backbone.Model(),
        textAttr: 'field_value',
        itemsAttr: 'field_values',
        history: false,
        wrapperClass: "select2-wrapper",
        select2Options: {
          data: this._buildSelect2FieldValues(fieldValues)
        },
        events: {
          "change select": ({ currentTarget }) => {
            this.model.set('fieldValue', currentTarget.value);
          }
        }
      });

      this.$el.find('.field-value-select2 .select2-initial').select2('destroy').remove(); // remove to clean up the wrapper div
      this._showValueSelect2();

      this.$el.find('.field-value-select2').append(filter.render().$el);
      if (this.model.get('inherited')) { // inherited tells us if the value was overridden, even if inheritedValue is set
        this.$el.find('.field-value-select2 .select2-initial').prop("disabled", true);
      }
    } else {
      this._showValueInput();
    }
  }

  _buildSelect2FieldValues(fieldValues) {
    return _.map(fieldValues, (value, index) => ({
      id: value,
      text: value,
      selected: this.model.get("fieldValue") === value
    }));
  }

  _filterOutSelectedFieldValue(fieldValue) {
    return this.model.get("fieldValue") !== fieldValue;
  }

  _showValueInput() {
    this.$el.find('.field-value-select2').hide();
    this.$el.find('[data-mount="custom-data-value"] [data-mount="input"]').show();
  }

  _showValueSelect2() {
    this.$el.find("[data-mount='custom-data-value'] [data-mount='input']").hide();
    this.$el.find('.field-value-select2').show();
  }

  _onRemoveClick() {
    this.$('[data-toggle=tooltip]').tooltip("dispose");
    if (_.isEmpty(this.model.get('inheritedValue'))) {
      this.removeSelectedField(this.model.get('fieldPartnerName'));
      this.closeItem();
    } else {
      this._storeInheritedValues(this.model.get('inheritedValue').data_owner_type, this.model.get('inheritedValue').value);
      this.$('.remove-custom-data-value').hide();
      this._onRestoreClick();
    }
    return false;
  }

  _onOverrideClick() {
    this.model.set("inherited", false);
    return false;
  }

  _onRestoreClick() {
    this.model.set("restore", true);
    return false;
  }

  _enableInputWhenPartnerNamePresent() {
    if (this.model.get("fieldPartnerName").length > 0) {
      this.$("[data-mount='custom-data-value'] [data-mount='input']").prop("disabled", false);
    }
  }
}
